/**
 * A coach-to-coachee share of a published learning resource.
 *
 * Hung off the coaching partnership, not the plan. Reassignment retires the
 * pairing, so the old coach's shares drop out of the live list.
 *
 * Temporary local type until `@efdigital/ll-addon-data` ships
 * `DataTypeCoaching.CoachingSharedResource`. Do not use a `…Like` stand-in —
 * this is the Warp Drive record shape the store returns.
 */
import type { CoachingPartnership, Resource } from '@efdigital/ll-addon-data';
import type { Type } from '@warp-drive/core/types/symbols';
import { type AsyncBelongsTo } from '@warp-drive/legacy/model';
import { type WithLegacy } from '@warp-drive/legacy/model/migration-support';

/** Warp Drive / kebab-case type. TypeNormalizerHandler maps the API camelCase. */
export const DataTypeCoachingSharedResource =
  'coaching-shared-resources' as const;

export type DataTypeCoachingSharedResource =
  typeof DataTypeCoachingSharedResource;

export type CoachingSharedResource = WithLegacy<{
  [Type]: DataTypeCoachingSharedResource;
  coachingPartnership: AsyncBelongsTo<CoachingPartnership>;
  resource: AsyncBelongsTo<Resource>;
  /** Owning coachee's user id. Stamped from the partnership on create. */
  user: string;
  /** Who shared it — the coach. Stamped from the caller on create. */
  createdByUserId: string;
  note: string;
  createdAt: string;
  modified: string;
}>;

export type SharedResourceItem = {
  share: CoachingSharedResource;
  resource: Resource | null;
};
